export default {
    onboarding: {
        actions: {
            mainBlue: 'Beginnen'
        }
    },
    details: {
        title: 'Zusätzliche Informationen',
        aboutProperty: 'Bitte bestätigen Sie uns die folgenden Informationen:',
        errorMsgInputTxt: 'Pflichtfelder',
        errorMsgGeneral: 'Überprüfen Sie das Formular, bevor Sie fortfahren',
        errorImages: 'Bitte fügen Sie Fotos hinzu, bevor Sie fortfahren.',
        address: {
            literal: 'Adresse',
            placeholder: 'Geben Sie einen Ort ein'
        },
        zipCode: {
            literal: 'Postleitzahl'
        },
        propertyType: {
            literal: 'Art der Immobilie',
            options: {
                appartment: 'Wohnung',
                maison: 'Haus',
                local_commercial: 'Geschäftslokal'
            }
        },
        residentType: {
            literal: 'Art des Bewohners',
            options: {
                propietarie: 'Eigentümer',
                locataire: 'Mieter',
                propietarie_non_occupant: 'Eigentümer Nicht bewohnend'
            }
        },
        moreThanTwoYears: {
            literal: 'Alter des Gebäudes',
            options: {
                less: 'Weniger als 2 Jahre',
                more: 'Mehr als 2 Jahre'
            }
        },
        observations: {
            literal: 'Bemerkungen'
        },
        map: {
            empty: {
                title: 'Ohne Adresse',
                text: 'Bitte geben Sie eine gültige Adresse ein.'
            }
        },
        textArea: {
            placeHolder: 'Die Textlänge ist auf maximal 255 Zeichen begrenzt'
        }
    },
    closing: {
        actions: {
            mobilierButton: 'Fahren Sie mit Möbelschäden fort'
        }
    },
    compensationType: {
        title: 'Noch nie war die Schadenabwicklung so einfach',
        subtitle: '�ber Ihren Sachschaden ',
        text: 'Dazu bieten wir drei mögliche Lösungen an:',
        recommended: 'Notre recommandation!',
        amount: 'Unsere Empfehlung!',
        e2eCompensations: {
            gagDetail: {
                title: 'Voulez vous faire vous-même?',
                text: 'Willst du es selbst machen?',
                link: 'Lassen Sie uns gemeinsam Ihren Bedarf abschätzen'
            },
            billma: {
                title: 'Vergütung auf Angebot',
                text: 'Fügen Sie Ihrer Rücksendung Fotos und Rechnungen der beschädigten Ware bei. Unsere technische Einheit wird es validieren.',
                link: 'Laden Sie Ihr Angebot'
            },
            renDetail: {
                title: 'Reparaturdienst',
                text: 'Nutzen Sie unseren Reparaturservice. Teilen Sie uns mit, wann Sie für einen Termin verfügbar sind.',
                link: 'Einen Termin machen'
            }
        }
    },
    compensationMobilier: {
        title: 'Zu Ihrem Sachschaden',
        subtitle: 'Höhe der Entschädigung',
        total: 'Gesamt:',
        totalAmount: 'Gesamtvergütung',
        actions: {
            primary: 'Ja, ich akzeptiere die vorgeschlagene Entschädigung',
            secondary: 'Ich möchte mit einem Berater sprechen'
        }
    }
}